import * as vendedor from '@/api/vendedor'
import { convertSelect } from '../../../service/collection'

const state = {
  list: [],
  listaSelect: [],
  filtros: {nome: '', cpf: '', empresa_id: null, page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfirma: false,
  comissaoVendedores: {
    pages: 0,
    registros: 0,
    list: []
  },
  filtrosComissao: {nome: '', cpf: '', empresa_id: null, page: 1},
  comerciais: {
    listRegionais: [],
    listSupervisores: [],
    listVendedores: []
  }
}

const mutations = {
  SETVENDEDORES (state, payload) {
    state.list = payload.list
  },
  SETVENDEDORESSELECT (state, payload) {
    state.listaSelect = convertSelect(payload)
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFIRMA (state) {
    state.modalConfirma = !state.modalConfirma
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGECOMISSAO (state, payload) {
    state.filtrosComissao.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETFILTROSCOMISSAO (state, payload) {
    if (payload) {
      state.filtrosComissao = payload
    }
  },
  SETCOMISSAOVENDEDORES (state, payload) {
    state.comissaoVendedores = payload
  },
  SETCOMERCIAISSELECT (state, payload) {
    state.comerciais.listRegionais = payload.regionais
    state.comerciais.listSupervisores = payload.supervisores
    state.comerciais.listVendedores = payload.vendedores
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfirma: function ({ commit }) {
    commit('MODALCONFIRMA')
  },
  async get ({ commit }, payload) {
    let data = await vendedor.get(payload)
    return data.instancia
  },
  async getVendedores ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await vendedor.getVendedores(payload)
    commit('SETVENDEDORES', data.instancia)
    commit('SETPAGINATE', data.instancia.pages)
  },
  async getVendedoresFiltro ({ commit, dispatch }) {
    let data = await vendedor.getVendedores(state.filtros)
    commit('SETVENDEDORES', data.instancia)
    if (state.filtros.page > data.pages) dispatch('setPage', data.instancia.pages)
    else {
      commit('SETVENDEDORES', data.instancia)
      commit('SETPAGINATE', data.instancia.pages)
    }
  },
  async add ({ commit }, payload) {
    let reg = await vendedor.add(payload)
    return reg.instancia
  },
  async edit ({ commit }, payload) {
    let reg = await vendedor.edit(payload)
    return reg.instancia
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getVendedores', state.filtros)
  },
  async getVendedoresSelect ({ commit }, payload) {
    let data = await vendedor.getVendedoresSemPaginacao(payload)
    commit('SETVENDEDORESSELECT', data.instancia)
  },
  async getVendedoresSelectSemCommit ({ commit }, payload) {
    let data = await vendedor.getVendedoresSemPaginacao(payload)
    if (data.instancia) return convertSelect(data.instancia)
    return []
  },
  async getComissaoVendedores ({ commit }, payload) {
    commit('SETFILTROSCOMISSAO', payload)
    let reg = await vendedor.getComissaoVendedores(payload)
    let instancia = reg.instancia
    instancia.list.forEach(element => {
      element.relatorio = []
      element.valor_assinaturas = 0
    })
    commit('SETCOMISSAOVENDEDORES', instancia)
    commit('SETPAGINATE', instancia.pages)
    return instancia
  },
  setPageComissao (context, payload) {
    context.commit('SETPAGECOMISSAO', payload)
    context.dispatch('getComissaoVendedores', state.filtrosComissao)
  },
  async getComissaoVendedoresNaoPaginado ({ commit }, payload) {
    let reg = await vendedor.getComissaoVendedoresNaoPaginado(payload)
    let instancia = reg.instancia
    return instancia
  },
  async geraChave () {
    let retorno = await vendedor.geraChave()
    return retorno.instancia
  },
  async addVinculandoUsuario ({ commit }, payload) {
    let reg = await vendedor.addVinculandoUsuario(payload)
    return reg.instancia
  },
  async editVinculandoUsuario ({ commit }, payload) {
    let reg = await vendedor.editVinculandoUsuario(payload)
    return reg.instancia
  },
  async getComerciaisSelect ({ commit }) {
    let regionais = await vendedor.getVendedoresSemPaginacao({ tipo: 'regional' })
    if (regionais.instancia) regionais = convertSelect(regionais.instancia)
    let supervisores = await vendedor.getVendedoresSemPaginacao({ tipo: 'supervisor' })
    if (supervisores.instancia) supervisores = convertSelect(supervisores.instancia)
    let vendedores = await vendedor.getVendedoresSemPaginacao({ tipo: 'vendedor' })
    if (vendedores.instancia) vendedores = convertSelect(vendedores.instancia)
    commit('SETCOMERCIAISSELECT', {regionais, supervisores, vendedores})
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/vendedor.js